import { render, staticRenderFns } from "./HorarioPage.vue?vue&type=template&id=e20d7cc2&scoped=true&"
import script from "./HorarioPage.vue?vue&type=script&lang=js&"
export * from "./HorarioPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20d7cc2",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/HorarioPage.vue
// module id = 210
// module chunks = 18